import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {FormBuilder, FormGroup} from '@angular/forms';
import {IFilterView, IPaginatorView, ISortView, PaginatorState, SortState} from "../crud-table";
import {HttpClient} from "@angular/common/http";
import {SweetAlertService} from "../shared/services/common/sweet-alert.service";

@Component({
  selector: 'app-base-bpmn-todo-pages',
  template: ``,
  styles: [],
})

export class BaseCrudBpmnTodoPagesComponent implements OnInit, OnDestroy, ISortView, IFilterView, IPaginatorView {
  // USE if not using alurkerja BE (Remove depedency OnInit AlurKerja BE)
  isLoading: boolean;
  public subscriptions: Subscription[] = [];
  filterGroup: FormGroup;
  sorting: SortState;
  paginator: PaginatorState;
  arrFormGroups: any[] = [];
  protected http: HttpClient;
  loadingStart = false;
  taskDef = '';
  itemsContent = [];

  constructor(
    @Inject('') protected tableService: any,
    protected fb: FormBuilder
  ) {}

  paginate(paginator: PaginatorState) {
    this.tableService.patchStateBpmn({ paginator }, this.taskDef);
  }

  create() {
    this.edit(undefined, 'edit', 'init');
  }

  edit(id: number, type: string = 'edit', typeTask = null) {

  }

  // OVERRIDE THIS FOR FILTER
  filterForm() {

  }

  // OVERRIDE THIS FOR FILTER
  filter() {

  }

  sort(column: string): void {
    const sorting = this.sorting;
    const isActiveColumn = sorting.column === column;
    if (!isActiveColumn) {
      sorting.column = column;
      sorting.direction = 'asc';
    } else {
      sorting.direction = sorting.direction === 'asc' ? 'desc' : 'asc';
    }
    this.tableService.patchStateBpmn({ sorting }, this.taskDef);
  }

  ngOnInit(): void {
    this.tableService.setDefaults();
    this.loadingStart = true;
    this.filterForm();
    this.tableService.fetchBpmnGeneral(this.taskDef);
    const sb = this.tableService.isLoading$.subscribe((res) => {
      this.isLoading = res
    });
    this.tableService.items$.subscribe((res) => {
      if (res.length) {
        this.itemsContent = [...res];
        this.loadingStart = false;
        this.toDoSomething();
      }
    }, (error) => {
      this.loadingStart = false;
    })
    this.tableService.errorMessage$.subscribe((res) => {
      if (typeof res == 'object') {
        if (res.hasOwnProperty('error')) {
          SweetAlertService.swalError(res);
        }
      }
    })
    this.subscriptions.push(sb);
    this.sorting = this.tableService.sorting;
    this.paginator = this.tableService.paginator;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }

  toDoSomething() {
  //  Override this
  }

}
